export default __webpack_public_path__ + "static/media/Quicksense Ring.2e7add2d.jpg";